export default {
  path: '/design-relatorio',
  name: 'Design Relatório',
  component: () => import('@/views/designRelatorio/index.vue'),
  meta: { requireAuth: true },
  children: []
}
